import React, { FC, useState } from 'react'
import { landingApi } from 'Pages/landings/newLandings/common/api'
import { FieldNames, OutLinks } from 'Pages/landings/newLandings/common/constants'
import { formatDateForBackend } from 'Pages/landings/newLandings/common/helpers'
import { useForm } from 'Pages/landings/newLandings/common/hooks'
import { Callback, InnDataModel } from 'Pages/landings/newLandings/common/types'
import { required } from 'Pages/landings/newLandings/common/validators'
import { ButtonComponent } from 'Pages/landings/newLandings/common/components'
import {
	StyledInnFormText,
	CheckboxText,
	CheckboxComponent,
	StyledInnFormTextHref,
	Input,
	StyledInnFormDescription,
	BtnWrapper,
	GridHalf,
	GridMiddleName,
	WrapperCheckbox,
} from './styled'

interface ComponentProps {
	item?: InnDataModel
	callbackSetInn?: (inn: string, lastName: string, firstName: string) => void
	closeModal: Callback
}

const { getInnRbidosRequestApi } = landingApi

export const InnFormComponent: FC<ComponentProps> = ({ item, callbackSetInn, closeModal }) => {
	const [noMiddleName, setNoMiddleName] = useState(false)
	const {
		formValue,
		setFormValue,
		createChangeHandler,
		getFormError,
		getFormValue,
		getFormDate,
		submit,
	} = useForm()

	const checkboxChange = () => {
		setNoMiddleName(!noMiddleName)
		setFormValue({ ...formValue, [FieldNames.MIDDLE_NAME]: '' })
	}

	const handleSubmit = async () => {
		const prepareValues = {
			documentNumber: `${formValue?.[FieldNames.PASSPORT_SERIES]} ${
				formValue?.[FieldNames.PASSPORT_NUMBER]
			}`,
			birthDate:
				formValue[FieldNames.BIRTH_DATE] && formatDateForBackend(formValue[FieldNames.BIRTH_DATE]),
			documentGivenDate:
				formValue[FieldNames.PASSPORT_GIVEN_DATE] &&
				formatDateForBackend(formValue[FieldNames.PASSPORT_GIVEN_DATE]),
			middleName: formValue[FieldNames.MIDDLE_NAME],
			lastName: formValue[FieldNames.LAST_NAME],
			firstName: formValue[FieldNames.FIRST_NAME],
		}

		try {
			const res = await getInnRbidosRequestApi(prepareValues)
			callbackSetInn(res?.inn, prepareValues.lastName, prepareValues.firstName)
		} catch (e) {
			// eslint-disable-next-line no-console
			console.log(e)
		}
	}

	return (
		<>
			<StyledInnFormText>
				Мы найдем ваш ИНН, для этого заполните форму и нажмите на кнопку «Узнать ИНН»
			</StyledInnFormText>
			<div className="ym-hide-content">
				<Input
					onChange={createChangeHandler({
						fieldName: FieldNames.LAST_NAME,
						validation: [required()],
						initialValue: item?.lastName ?? '',
					})}
					placeholder="Фамилия"
					name={FieldNames.LAST_NAME}
					value={getFormValue(FieldNames.LAST_NAME)}
					error={getFormError(FieldNames.LAST_NAME)}
				/>
				<Input
					onChange={createChangeHandler({
						fieldName: FieldNames.FIRST_NAME,
						validation: [required()],
						initialValue: item?.firstName ?? '',
					})}
					placeholder="Имя"
					name={FieldNames.FIRST_NAME}
					value={getFormValue(FieldNames.FIRST_NAME)}
					error={getFormError(FieldNames.FIRST_NAME)}
				/>
				<GridMiddleName>
					<Input
						onChange={createChangeHandler({
							fieldName: FieldNames.MIDDLE_NAME,
							validation: noMiddleName ? [] : [required()],
							initialValue: '',
						})}
						disabled={noMiddleName}
						placeholder="Отчество"
						name={FieldNames.MIDDLE_NAME}
						value={getFormValue(FieldNames.MIDDLE_NAME)}
						error={getFormError(FieldNames.MIDDLE_NAME)}
					/>
					<WrapperCheckbox>
						<CheckboxComponent name="ModalInnForm" checked={noMiddleName} onChange={checkboxChange}>
							<CheckboxText>Нет отчества</CheckboxText>
						</CheckboxComponent>
					</WrapperCheckbox>
				</GridMiddleName>
				<GridHalf>
					<Input
						onChange={createChangeHandler({
							fieldName: FieldNames.PASSPORT_SERIES,
							validation: [required()],
							initialValue: '',
						})}
						placeholder="Серия паспорта"
						name={FieldNames.PASSPORT_SERIES}
						value={getFormValue(FieldNames.PASSPORT_SERIES)}
						error={getFormError(FieldNames.PASSPORT_SERIES)}
						mask="99 99"
						input="phone"
					/>
					<Input
						onChange={createChangeHandler({
							fieldName: FieldNames.PASSPORT_NUMBER,
							validation: [required()],
							initialValue: '',
						})}
						placeholder="Номер паспорта"
						name={FieldNames.PASSPORT_NUMBER}
						value={getFormValue(FieldNames.PASSPORT_NUMBER)}
						error={getFormError(FieldNames.PASSPORT_NUMBER)}
						mask="999999"
						input="phone"
					/>
				</GridHalf>
				<Input
					onChange={createChangeHandler({
						fieldName: FieldNames.PASSPORT_GIVEN_DATE,
						validation: [required()],
						initialValue: '',
					})}
					placeholder="Дата выдачи паспорта"
					value={getFormDate(FieldNames.PASSPORT_GIVEN_DATE)}
					error={getFormError(FieldNames.PASSPORT_GIVEN_DATE)}
					input="date"
				/>
				<Input
					onChange={createChangeHandler({
						fieldName: FieldNames.BIRTH_DATE,
						validation: [required()],
						initialValue: '',
					})}
					value={getFormDate(FieldNames.BIRTH_DATE)}
					error={getFormError(FieldNames.BIRTH_DATE)}
					placeholder="Дата рождения"
					input="date"
				/>
				<StyledInnFormDescription>
					Нажимая на кнопку «Узнать ИНН», вы соглашаетесь на&nbsp;
					<StyledInnFormTextHref href={OutLinks.getYourInnPolicyHref} target="_blank">
						обработку персональных данных
					</StyledInnFormTextHref>
				</StyledInnFormDescription>
				<BtnWrapper>
					<ButtonComponent type="tertiary" measure="l" text="Закрыть" onClick={closeModal} />
					<ButtonComponent
						type="primary"
						measure="l"
						text="Узнать ИНН"
						onClick={() => submit(handleSubmit)}
					/>
				</BtnWrapper>
			</div>
		</>
	)
}
